import BigNumber from 'bignumber.js';

export const getRounded = (n: number, multiple = 1): number =>
    BigNumber(multiple)
        .times(BigNumber(n).div(multiple).integerValue(BigNumber.ROUND_HALF_UP))
        .toNumber();

export const getRoundedDown = (n: number, multiple = 1): number =>
    BigNumber(multiple)
        .times(BigNumber(n).div(multiple).integerValue(BigNumber.ROUND_DOWN))
        .toNumber();

export const getRoundedUp = (n: number, multiple = 1): number =>
    BigNumber(multiple)
        .times(BigNumber(n).div(multiple).integerValue(BigNumber.ROUND_UP))
        .toNumber();
